import './TextInputWithTokens-fb9b5109.css';

var styles = {"TextInputWrapper":"prc-TextInputWithTokens-TextInputWrapper-kj1cB","UnstyledTextInput":"prc-TextInputWithTokens-UnstyledTextInput-F582M","InputWrapper":"prc-TextInputWithTokens-InputWrapper-wloGg","Container":"prc-TextInputWithTokens-Container-mBzq-"};

export { styles as default };
